import React from 'react';
import { graphql, compose } from 'react-apollo';

import PackageList from 'Components/Presentation/ETL/PackageList';

import AllPackagesQuery from 'GraphQueries/EtlPackages/AllQuery';
import NewPackageMutation from 'GraphQueries/EtlPackages/NewMutation';
import NewPackageSubscription from 'GraphQueries/EtlPackages/NewSubscription';
import DeletePackageMutation from 'GraphQueries/EtlPackages/DeleteMutation';
import PackageDeletedSubscription from 'GraphQueries/EtlPackages/DeleteSubscription';

class EtlPackageList extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            etlPackage: null
        }
    }

    static defaultProps = {
        etlPackages: [],        
    }

    componentDidMount() {
        this.props.subscribeToChanges();
    }

    savePackage = async (etlPackage) => {
        const { history } = this.props;
        await this.props.onAdd(etlPackage);
        history.push(`/data-tools/etl-packages/${etlPackage.id}/v1/manage`);
    }

    deletePackage = async (etlPackage) => {
        await this.props.onDelete(etlPackage);
    }

    render() {
        const { etlPackages, history } = this.props;
        return (<PackageList history={history} etlPackages={etlPackages} onPackageAdded={this.savePackage} onPackageRemoved={this.deletePackage} />);
    }
}

export default compose(
    graphql(AllPackagesQuery, {
        options: {
            fetchPolicy: 'cache-and-network' //network-only
        },
        props: (props) => ({
            etlPackages: props.data.listEtlPackages && props.data.listEtlPackages.items,
            subscribeToChanges: params => {
                props.data.subscribeToMore({
                    document: NewPackageSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onCreateEtlPackage } } }) => ({
                        ...prev,
                        listEtlPackages: { items: [onCreateEtlPackage, ...prev.listEtlPackages.items.filter(item => item.id !== onCreateEtlPackage.id)], __typename: 'EtlPackage' }
                    })
                });
                props.data.subscribeToMore({
                    document: PackageDeletedSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onDeleteEtlPackage } } }) => ({
                        ...prev,
                        listEtlPackages: { items: [...prev.listEtlPackages.items.filter(item => item.id !== onDeleteEtlPackage.id)], __typename: 'EtlPackage' }
                    })
                });
            }
        }),

    }),
    graphql(DeletePackageMutation, {
        props: (props) => ({
            onDelete: (etlPackage) => props.mutate({
                variables: { id: etlPackage.id, version: etlPackage.version },
                optimisticResponse: () => ({ deleteEtlPackage: { ...etlPackage, __typename: 'EtlPackage' } }),
            })
        }),
        options: {
            refetchQueries: [{ query: AllPackagesQuery }],
            update: (proxy, { data: { deleteEtlPackage: { id, version } } }) => {
                const query = AllPackagesQuery;
                const data = proxy.readQuery({ query });

                data.listEtlPackages.items = data.listEtlPackages.items.filter(etlPackage => etlPackage.id !== id && etlPackage !== version);

                proxy.writeQuery({ query, data });
            }
        }
    }),
    graphql(NewPackageMutation, {
        props: (props) => ({
            onAdd: etlPackage =>
                props.mutate({
                    variables: { ...etlPackage },
                    optimisticResponse: () => ({ createEtlPackage: { version: 1, scale: 1, objects: [], queries: [], matrix: [1, 0, 0, 1, 0, 0], ...etlPackage, __typename: 'EtlPackage' } }),
                })
        }),
        options: {
            refetchQueries: [{ query: AllPackagesQuery }],
            update: (dataProxy, { data: { createEtlPackage } }) => {
                const query = AllPackagesQuery;
                const data = dataProxy.readQuery({ query });

                data.listEtlPackages.items.push(createEtlPackage);
                dataProxy.writeQuery({ query, data });
            }
        }
    })
)(EtlPackageList);


// WEBPACK FOOTER //
// ./src/Components/Containers/EtlPackages/List.js